import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export const TextEditorDialog = ({ show, text, onHide, onSave, onChange }) => {
  return (
    <>
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>CV Text</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={text || ""}
              onChange={(e) => onChange(e.target.value)}
              placeholder="Enter your CV text here..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Close</Button>
          <Button variant="primary" onClick={onSave}>Save Changes</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
